const backendURLs = {
    develop: 'http://vad-zelfhulptool.docker/api/v1',
    staging: 'https://039005-5f03-03a3-0001.staging.d.bitsof.love/api/v1',
    master:
        'https://039005-5f03-03a3-0001.production.web1.d.bitsof.love/api/v1',
};

const appURLs = {
    staging: 'https://039005-5f03-03a3-0001.staging.s.bitsof.love/#/',
    master: 'https://www.druglijn.be/grip/kind-van#/',
};

const app = 'zelfhulptool';
const baseURL = backendURLs[process.env.CIRCLE_BRANCH];
const appURL = appURLs[process.env.CIRCLE_BRANCH];

export { app, baseURL, appURL };



// WEBPACK FOOTER //
// ./src/constants.js